import * as _ from 'lodash-es';
import type { TableDocumentColumn, TableDocumentRow } from './types';
import type {
  ColumnSelection,
  RowSelection,
  TableSelection,
} from './useTableSelection';
import { SelectionType } from './useTableSelection';

type RangeSelection = TableSelection | RowSelection | ColumnSelection;

const getRangeSelectionIndexes = (
  selection: RangeSelection,
  {
    rows = [],
    columns = [],
  }: { rows?: TableDocumentRow[]; columns?: TableDocumentColumn[] },
) => {
  let rowIndexes: number[] = [];
  let columnIndexes: number[] = [];
  switch (selection.type) {
    case SelectionType.Table:
      rowIndexes = _.range(rows.length);
      columnIndexes = _.range(columns.length);
      break;
    case SelectionType.Row:
      rowIndexes = selection.rows.toSorted((a, b) => a - b);
      columnIndexes = _.range(columns.length);
      break;
    case SelectionType.Column:
      rowIndexes = _.range(rows.length);
      columnIndexes = selection.columns.toSorted((a, b) => a - b);
      break;
    default:
      break;
  }

  return { rowIndexes, columnIndexes };
};

export default getRangeSelectionIndexes;
